import React from 'react'

const MyButton = ({text, faicon}) => {
  return (
    <div className="my-cstm-btn">
        <button> {text}</button>
        <i className= {`fa ${faicon} my-arrow`}></i>
    </div>
  )
}

export default MyButton
